import { getToken } from "./auth";

const BASE_URL = process.env.REACT_APP_BASE_URL; // ✅ match your .env

export const apiFetch = async (endpoint, options = {}) => {
  const token = getToken();

  if (!BASE_URL) {
    throw new Error(
      "❌ BASE_URL is not defined. Did you set REACT_APP_BASE_URL in .env?"
    );
  }

  const response = await fetch(`${BASE_URL}${endpoint}`, {
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...(options.headers || {}),
    },
  });

  if (!response.ok) {
    const errorText = await response.text();
    throw new Error(`❌ API Error ${response.status}: ${errorText}`);
  }

  return response.json();
};
